<script setup lang="ts">
import type { PropertyOnPage } from '@@/shared/property/api-types';
import type { DialogMediaType } from '@@/shared/property/media';

defineProps<{
  property: PropertyOnPage
}>();

const modelValue = defineModel<DialogMediaType>({ default: `photo` });
</script>

<template>
  <div>
    <IadRadioGroup
      v-model="modelValue"
      hide-details
    >
      <IadRadio
        v-if="property.photos.length"
        value="photo"
        :label="$t(`property.filters.photo.length`, { count: property.photos.length })"
      />
      <IadRadio
        v-if="property.virtualTours?.length"
        value="virtual-tour"
        :label="$t(`property.gallery.virtual_tour.count`, { count: property.virtualTours.length })"
      />
      <IadRadio
        v-if="property.videos?.length"
        value="video"
        :label="$t(`property.gallery.video.count`, { count: property.videos.length })"
      />
    </IadRadioGroup>
  </div>
</template>
